export class Gallery {
    constructor({offerGalleryId, offerGalleryImages, modalId, modalGalleryId}) {
        this.galleryIndex = 0;
        this.zoomed = null;
        this.init(modalGalleryId, offerGalleryImages, modalId, offerGalleryId);
    }

    async init(modalGalleryId, offerGalleryImages, modalId, offerGalleryId) {
        let galleryEl = null;
        while (!galleryEl) {
            galleryEl = document.querySelector(offerGalleryId);
            let {sleep} = await import('../utils/sleep');
            await sleep(300);
        }
        if (galleryEl === null) {
            return;
        }
        this.zoomUpEl = document.querySelector('[data-zoom-up]');
        this.zoomDownEl = document.querySelector('[data-zoom-down]');
        this.modalGalleryDots = document.querySelectorAll('[data-slider-index]');
        this.currentEl = document.querySelector('.offer-gallery-current');
        this.offerGallery = await this.initOfferGallery(galleryEl);
        this.modalGallery = await this.initModalGallery(document.querySelector(modalGalleryId));
        this.modal = this.initModal(document.querySelector(modalId), offerGalleryImages);

        /**
         * gallery grid toggler
         */
        let galleryGridWrapperList = document.querySelectorAll('.gallery-grid-wrapper');
        galleryGridWrapperList.forEach(function (galleryGridWrapper) {
            let toggler = galleryGridWrapper.querySelector('.gallery-grid-wrapper__toggler');

            toggler.addEventListener('click', function (event) {
                galleryGridWrapper.classList.add('gallery-grid-wrapper--active');
            });
        });
    }

    async initOfferGallery(galleryEl) {
        let {default: Glide, Controls, Swipe} = await import('@glidejs/glide/entry/entry-modular');
        let gallery = (new Glide(galleryEl)).mount({Controls, Swipe});
        let images = galleryEl.querySelectorAll('.offer-gallery-main__img');

        gallery.on('run', () => {
            this.galleryIndex = gallery.index;
            this._recalculateSlideCounter();
            this._loadImage(images, gallery.index - 1);
            this._loadImage(images, gallery.index);
            this._loadImage(images, gallery.index + 1);
        });

        galleryEl.addEventListener('mouseover', () => {
            const arrowsContainer = galleryEl.querySelector('.glide__arrows');
            const buttons = galleryEl.querySelectorAll('.glide__arrow');
            buttons.forEach(btn => {
                btn.style.display = 'block';
            });
            if (arrowsContainer) {
                arrowsContainer.style.display = 'block';
            }
        });

        galleryEl.addEventListener('mouseout', () => {
            const arrowsContainer = galleryEl.querySelector('.glide__arrows');
            const buttons = galleryEl.querySelectorAll('.glide__arrow');
            buttons.forEach(btn => {
                btn.style.display = 'none';
            });
            if (arrowsContainer) {
                arrowsContainer.style.display = 'none';
            }
        });

        return gallery;
    }

    async initModalGallery(galleryEl) {
        let {default: Glide, Controls, Swipe} = await import('@glidejs/glide/entry/entry-modular');
        let gallery = (new Glide(galleryEl)).mount({Controls, Swipe});
        let images = galleryEl.querySelectorAll('.offer-gallery-magnifier__img');

        gallery.on('run', () => {
            this.galleryIndex = gallery.index;
            this._recalculateSlideCounter();
            this._loadImage(images, gallery.index - 1);
            this._loadImage(images, gallery.index);
            this._loadImage(images, gallery.index + 1);
        });

        gallery.on('run.after', evt => {
            this.modalGalleryDots.forEach(dot => {
                dot.classList.remove('gallery-grid__item--active');
            });
            this._currentDot().classList.add('gallery-grid__item--active');

            this._destroyZoom();
        });

        this.zoomUpEl.addEventListener('click', evt => this._onZoomUpClick(evt, images[this.galleryIndex]));
        this.zoomDownEl.addEventListener('click', evt => this._onZoomDownClick(evt, images[this.galleryIndex]));
        galleryEl.querySelectorAll('.glide__arrow').forEach(arrow => {
            arrow.addEventListener('click', evt => {
                if (this.zoomed != null) {
                    this._destroyZoom();
                    this.modalGallery.go(arrow.dataset.glideDir);
                }
            });
        });

        this.modalGalleryDots.forEach((dot, i) => {
            dot.addEventListener('click', evt => {
                this._destroyZoom();
                this.modalGallery.go('=' + i);
            });
        });

        return gallery;
    }

    async initModal(modalEl, openSelector) {
        let {default: Modal} = await import('bootstrap/js/dist/modal');
        let modal = new Modal(modalEl);
        let mainGalleryImageListEl = document.querySelectorAll(openSelector, modalEl);
        mainGalleryImageListEl.forEach(image => {
            image.addEventListener('click', () => {
                modal.show();
            });
        });
        const offerGalleryMoreElement = document.querySelector('.offer-gallery-more');
        if (offerGalleryMoreElement) {
            offerGalleryMoreElement.addEventListener('click', () => {
                modal.show();
            });
        }

        modalEl.addEventListener('show.bs.modal', () => {
            this.modalGallery.go('=' + this.galleryIndex);
        });

        modalEl.addEventListener('shown.bs.modal', () => {
            this.modalGallery.mount();
        });

        modalEl.addEventListener('hide.bs.modal', () => {
            if ((this.galleryIndex + 1) > mainGalleryImageListEl.length) {
                this.galleryIndex = 0;
            }

            this.offerGallery.go('=' + this.galleryIndex);
        });

        return modal;
    }

    _currentDot() {
        return this.modalGalleryDots[this.galleryIndex];
    }

    _recalculateSlideCounter() {
        this.currentEl.textContent = (this.galleryIndex + 1);
    }

    async _loadImage(imageList, index) {
        if (!(index in imageList)) {
            return;
        }
        let image = imageList[index];

        if (image.classList.contains('loaded')) {
            return;
        }
        let {default: LazyLoad} = await import('vanilla-lazyload');
        LazyLoad.load(image);
    }

    async _onZoomUpClick(evt, image) {
        if (this.zoomed == null) {
            this.zoomed = await this._createZoom(image);
        }

        this.zoomed.zoomUp();
    }

    _onZoomDownClick(evt, image) {
        if (this.zoomed == null) {
            return;
        }

        this.zoomed.zoomDown();
    }

    _recalculateZoomButtons() {
        if (this.zoomed == null) {
            this.zoomDownEl.classList.add('offer-gallery-zoom--disabled');
            this.zoomDownEl.disabled = true;
            this.zoomUpEl.classList.add('offer-gallery-zoom--disabled');
            this.zoomUpEl.disabled = true;
            return;
        }

        let content = this.zoomed.content;

        if (content.currentScale <= content.minScale) {
            this.zoomDownEl.classList.add('offer-gallery-zoom--disabled');
            this.zoomDownEl.disabled = true;
        } else {
            this.zoomDownEl.classList.remove('offer-gallery-zoom--disabled');
            this.zoomDownEl.disabled = false;
        }

        if (content.currentScale >= content.maxScale) {
            this.zoomUpEl.classList.add('offer-gallery-zoom--disabled');
            this.zoomUpEl.disabled = true;
        } else {
            this.zoomUpEl.classList.remove('offer-gallery-zoom--disabled');
            this.zoomUpEl.disabled = false;
        }
    }

    async _createZoom(image) {
        let {default: Wzoom} = await import('vanilla-js-wheel-zoom');
        let currentClass = this;
        let zoom = Wzoom.create(image, {
            minScale: 1,
            maxScale: 2,
            speed: 4,
            dragScrollableOptions: {
                smoothExtinction: 0
            },
            zoomOnClick: false,
            rescale: function () {
                currentClass._recalculateZoomButtons();
            }
        });

        this.modalGallery.disable();

        return zoom;
    }

    _destroyZoom() {
        if (this.zoomed != null) {
            this.zoomed.maxZoomDown();
            this.zoomed.prepare();
            this.zoomed.destroy();
            this.zoomed = null;
        }

        this.modalGallery.enable();
    }
}
